// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Landing from "../../templates/Landing.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

var heroImg = {
  src: "https://images.instapainting.com/626271dc9f214c72238b458b.jpg",
  alt: "Oil portrait of an old dog sitting"
};

var pageTitle = "Hand-Painted Custom Portrait Oil Paintings";

var title = "Custom Portrait Painting.";

var title2 = " Real Paint on Canvas";

var metaDescription = "Just upload a photo and get a 100% hand-made portrait painting from a master portrait artist in oil, watercolor, charcoal, or other mediums. Free shipping and 100% money-back guarantee.";

var description = "Get a 100% hand-made portrait painting from a master portrait artist in oil, watercolor, charcoal, or other mediums. Free shipping and 100% money-back guarantee. Unlimited revisions included with all orders. All artworks are painted or drawn by hand in real life by a real artist, and shipped to your door.";

var mainCta = {
  text: "Upload a Photo",
  link: "/assets"
};

var altCta = {
  text: "Browse Portrait Paintings",
  link: "/gallery/portrait-paintings"
};

var products = [
  {
    title: "Oil Painting",
    src: "https://images.instapainting.com/62567f67efbb5e323c8b456d.jpg?fp-z=2.05&fp-x=0.5&fp-y=0.35",
    imageAlt: "Portrait oil painting of a woman and her baby",
    sku: "custphotoreal",
    price: 89
  },
  {
    title: "Watercolor",
    src: "https://images.instapainting.com/5975d3b187456fab518b456b.jpg?fp-z=1.9&fp-y=0.35",
    imageAlt: "Watercolor painting of a woman in the style of Flower Market",
    sku: "custwatercolor",
    price: 89
  },
  {
    title: "Charcoal",
    src: "https://images.instapainting.com/625ec46dcc372565108b4567.jpg?fp-z=1.25&fp-y=0.4&fp-x=0.47",
    imageAlt: "Charcoal drawing a male and female couple",
    sku: "custcharcoal",
    price: 89
  },
  {
    title: "Pencil Drawing",
    src: "https://images.instapainting.com/61c09a5e6d24b3b6008b458a.jpg?fp-z=1.4&fp-y=0.4",
    imageAlt: "Pencil drawing of a couple kissing",
    sku: "custpencil",
    price: 89
  },
  {
    title: "Colored-Pencil",
    src: "https://images.instapainting.com/62791b899f214c54b38b456f.jpg?fp-z=2.2",
    imageAlt: "Colored pencil drawing of a person kissing a dog",
    sku: "custpencil",
    price: 89
  }
];

var reviews = [
  {
    name: "Alexandra",
    location: "Anchorage, US",
    review: "Really nice painted portrait, if i did another i would send additional pictures of the faces in the picture to add clarity but it is still really nice",
    link: "/products/gallery/custwatercolor/580bc07c87456f9f508b456f?order=1",
    image: "https://images.instapainting.com/581819d687456fc52e8b4567.jpg?fit=crop&crop=faces&fp-y=.25&fp-z=2",
    imageAlt: "Portrait of a man in a suit holding his dog",
    date: new Date("11/15/2016")
  },
  {
    name: "Andrew",
    location: "North Olmsted, US",
    review: "Hello: We received our painting. It is absolutely W.O.N.D.E.R.F.U.L. We could not ask for anything better. Absolutely incredible !!!! 10 ********** My mother in law cried a river. She is so happy !!!!! You made the process so easy and the communication was fantastic too. For Christmas, I am going to order a photo of our little Yorkie for my wife. She will be the next one to flood the house with tears of joy ! Thank you again !!!! Great Job !!! Andrew Falensky ",
    link: "/products/gallery/custphotoreal/626c895f8896c751628b457e/?order=1",
    image: "https://images.instapainting.com/627868b58896c7b5ae8b4571.jpg?fit=crop&crop=faces",
    imageAlt: "Portrait painting in oil of an older gentlman alongside a younger gentleman.",
    date: new Date("5/18/2022")
  },
  {
    name: "Marie",
    location: "Fairfax, US",
    review: "Haerim took a blurry photo from 2013 and gave me a painting that so much exceeded my expectations; she really got the expressions on their faces. All three dogs have passed on now and I wanted something special that expressed the joy these three misfit dogs had, my Musketeers, and now I have it. Thank you so much for this wonderful memorial to my buddies.",
    link: "/products/gallery/custphotoreal/6258392c17bbaad9578b4574/?order=1",
    image: "https://images.instapainting.com/6265da358896c7b8358b456c.jpg",
    imageAlt: "3 dogs painted in the style of Dynamism of a Cyclist by Umberto Boccioni.",
    date: new Date("04/28/2022")
  }
];

var contentBlocks = [
  {
    title1: "What is a",
    title2: "Portrait Painting?",
    body: "Typically, a portrait painting is a hand-painted depiction of a person’s face, where the individual and their facial expression and personality can be seen. Many of the great artwork you will see in our gallery fit this description, however, our talented artists can work from any photograph and perfectly capture the moments that matter most to you!"
  },
  {
    title1: "How Long Does it Take To",
    title2: "Paint a Portrait?",
    body: "Our typical turnaround times generally range from 5-15 days, for all of our products. The specific turnaround time for your portrait project can vary based on your unique requirements like your artwork size. Expedited shipping ranges from 3-5 business days, and Economy Saver shipping can take up to 4 weeks for transit. With expedited shipping, most orders are at your door around 3 weeks from ordering, and with economy saver shipping it can take 4-6 weeks."
  }
];

function PortraitPaintingsPage(props) {
  return JsxRuntime.jsx(Landing.LandingPage.make, {
              pageTitle: pageTitle,
              heroImg: heroImg,
              youtubeVideo: "https://www.youtube-nocookie.com/embed/YgOCNegY4Xg",
              title: title,
              title2: title2,
              description: description,
              metaDescription: metaDescription,
              mainCta: mainCta,
              altCta: altCta,
              products: products,
              reviews: reviews,
              contentBlocks: contentBlocks
            });
}

var make = PortraitPaintingsPage;

var $$default = PortraitPaintingsPage;

export {
  heroImg ,
  pageTitle ,
  title ,
  title2 ,
  metaDescription ,
  description ,
  mainCta ,
  altCta ,
  products ,
  reviews ,
  contentBlocks ,
  make ,
  $$default as default,
}
/*  Not a pure module */
